/* ASKVAULT product Q&A — ask-form submitter.
   Tracks the variant the customer is viewing (gc:variant:change event, with a
   DOM fallback) and POSTs the question to the gc-ops Worker. */
(function () {
  var root = document.querySelector('[data-gcqa]');
  if (!root) return;

  var form = root.querySelector('[data-gcqa-form]');
  var msg = root.querySelector('[data-gcqa-msg]');
  var submit = root.querySelector('[data-gcqa-submit]');
  var tsField = root.querySelector('[data-gcqa-ts]');
  var endpoint = root.getAttribute('data-gcqa-endpoint');
  var handle = root.getAttribute('data-gcqa-handle');
  var title = root.getAttribute('data-gcqa-title');

  // Stamp form-render time for the server-side timestamp guard.
  if (tsField) tsField.value = String(Date.now());

  // --- track current variant ---
  var current = { id: null, title: null };

  function applyVariant(v) {
    if (!v) return;
    current.id = v.id != null ? String(v.id) : current.id;
    // Shopify variant objects expose `title`; some use option arrays.
    if (v.title) current.title = v.title;
    else if (v.public_title) current.title = v.public_title;
    else if (v.name) current.title = v.name;
  }

  // Primary source: the storefront's own variant-change broadcast.
  document.addEventListener('gc:variant:change', function (e) {
    applyVariant(e.detail);
  });

  // Fallback: read the product JSON + the hidden variant input on load.
  (function seedFromDom() {
    try {
      var input = document.querySelector('[data-variant-id]');
      var pj = document.querySelector('script[data-product-json]');
      var data = pj ? JSON.parse(pj.textContent) : null;
      var vid = input ? String(input.value) : null;
      if (data && data.variants && vid) {
        for (var i = 0; i < data.variants.length; i++) {
          if (String(data.variants[i].id) === vid) {
            applyVariant(data.variants[i]);
            break;
          }
        }
      } else if (vid) {
        current.id = vid;
      }
    } catch (err) {
      /* non-fatal */
    }
  })();

  function setMsg(text, isErr) {
    if (!msg) return;
    msg.textContent = text;
    msg.classList.toggle('gcqa__msg--err', !!isErr);
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = (form.email.value || '').trim();
    var question = (form.question.value || '').trim();
    if (!email || !question) {
      setMsg('Email and question are required.', true);
      return;
    }

    var payload = {
      handle: handle,
      title: title,
      email: email,
      name: (form.name.value || '').trim(),
      question: question,
      variant_id: current.id,
      variant_title: current.title,
      hp: form.hp.value || '',
      ts: Number(tsField ? tsField.value : 0),
    };

    submit.disabled = true;
    setMsg('Sending…', false);

    // A privacy filter that sinkholes the request would otherwise hang
    // "Sending…" forever — abort after 15s and tell the customer what to do.
    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timedOut = false;
    var timer = setTimeout(function () {
      timedOut = true;
      if (controller) controller.abort();
    }, 15000);

    var BLOCKED_MSG =
      'We couldn’t reach the Q&A service — an ad-blocker or privacy filter ' +
      'may be blocking it. Please try again, or email us at hello@gadgetconnections.com ' +
      'and we’ll answer directly.';

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      signal: controller ? controller.signal : undefined,
    })
      .then(function (r) {
        return r.json().then(function (d) {
          return { ok: r.ok, d: d };
        });
      })
      .then(function (res) {
        clearTimeout(timer);
        if (res.ok && res.d && res.d.ok) {
          form.reset();
          if (tsField) tsField.value = String(Date.now());
          setMsg(res.d.message || "Thanks! We'll email you the answer.", false);
        } else {
          setMsg((res.d && res.d.error) || 'Something went wrong. Try again.', true);
        }
        submit.disabled = false;
      })
      .catch(function () {
        clearTimeout(timer);
        setMsg(timedOut ? BLOCKED_MSG : 'Network error. Please try again.', true);
        submit.disabled = false;
      });
  });
})();
